import useAuthChecker from '../hooks/useAuthChecker';
import { AuthConfig } from '../types/auth';

type ComponentGuardProps = {
  auth?: AuthConfig;
  children: React.ReactNode;
  label?: string;
};

const ComponentGuard = ({ children, auth, label }: ComponentGuardProps) => {
  const { isAuthed, isChecking } = useAuthChecker(auth, label);

  if (isChecking) {
    return null;
  }

  if (isAuthed) {
    return <>{children}</>;
  }

  return null;
};

export default ComponentGuard;
